import React, { useEffect, useState } from "react";
import { usePrimaryOrganization } from "../../../hooks";
import {
  PrivacyNoticeChecklistItems,
  usePrivacyNoticeChecklistItems,
} from "../PrivacyNoticeChecklistItems";
import { StandardPageWrapper } from "../../../components/layout/StandardPageWrapper";
import { Loading } from "../../../components";
import { TopNavigationBreadcrumb } from "../../../components/privacyCenter/TopNavigationBreadcrumb";

export const HRNoticesInstructionsPage = () => {
  const [org] = usePrimaryOrganization();

  const [readyToRender, setReadyToRender] = useState(false);

  const { checklistProps, ready } = usePrivacyNoticeChecklistItems(org.devInstructionsId);

  useEffect(() => {
    if (ready) {
      setReadyToRender(true);
    }
  }, [ready]);

  if (!readyToRender) {
    return (
      <StandardPageWrapper>
        <Loading />
      </StandardPageWrapper>
    );
  }

  return (
    <StandardPageWrapper>
      <TopNavigationBreadcrumb source="HR Center" title="HR Notices" />

      {checklistProps?.notices && (
        <PrivacyNoticeChecklistItems
          {...checklistProps}
          stayCompliant={true}
          isHr={true}
          isPublicView={false}
        />
      )}
    </StandardPageWrapper>
  );
};
